import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root',
})
export class EnvironmentService {
    private devConfig = {
        clientId: '89a8a7af-8544-41b6-8b69-15c7b58a42ae',
        subValue: 'e508687475cb494885aa5309815d9c98',

        azureEncKey:
            '2F423F4528482B4D6251655468566D597133743677397A24432646294A404E635266556A586E5A7234753778214125442A472D4B6150645367566B59703373357638792F423F4528482B4D6251655468576D5A7134743777397A24432646294A404E635266556A586E3272357538782F413F442A472D4B6150645367566B59703373367639792442264529482B4D6251655468576D5A7134743777217A25432A462D4A614E635266556A586E3272357538782F413F4428472B4B6250655367566B5970337336763979244226452948404D635166546A576D5A7134743777217A25432A462D4A614E645267556B58703272357538782F413F4428472B4B625065',
        reCaptchaSiteKey: '6Lf9UZgqAAAAAFbFO2DNEP1eG19xHGOXFk6GEqoz', // * actual key
        instrumentationKey: '8e8f06d1-b756-4918-83b2-d0ba2143dafe',
        testEmailIds: 'sivakumar.ilango@enerpac.com',
        blobPublic: 'https://idmsstorageaccount.blob.core.windows.net/dev-public/',
    };
    private qaConfig = {
        clientId: 'a07bf348-d327-4ab3-8d07-a7e4d6cab020',
        subValue: 'e508687475cb494885aa5309815d9c98',

        azureEncKey:
            '2F423F4528482B4D6251655468566D597133743677397A24432646294A404E635266556A586E5A7234753778214125442A472D4B6150645367566B59703373357638792F423F4528482B4D6251655468576D5A7134743777397A24432646294A404E635266556A586E3272357538782F413F442A472D4B6150645367566B59703373367639792442264529482B4D6251655468576D5A7134743777217A25432A462D4A614E635266556A586E3272357538782F413F4428472B4B6250655367566B5970337336763979244226452948404D635166546A576D5A7134743777217A25432A462D4A614E645267556B58703272357538782F413F4428472B4B625065',
        reCaptchaSiteKey: '6Lf9UZgqAAAAAFbFO2DNEP1eG19xHGOXFk6GEqoz',
        instrumentationKey: '8e8f06d1-b756-4918-83b2-d0ba2143dafe',

        testEmailIds: 'sivakumar.ilango@enerpac.com',
        blobPublic: 'https://idmsstorageaccount.blob.core.windows.net/dev-public/',
    };
    private uatConfig = {
        clientId: '234f9b97-886c-499e-83a0-e58f4df2adc2',
        subValue: 'b579efd9ddad4c2690cbd0b528318a38',

        azureEncKey:
            '2F423F4528482B4D6251655468566D597133743677397A24432646294A404E635266556A586E5A7234753778214125442A472D4B6150645367566B59703373357638792F423F4528482B4D6251655468576D5A7134743777397A24432646294A404E635266556A586E3272357538782F413F442A472D4B6150645367566B59703373367639792442264529482B4D6251655468576D5A7134743777217A25432A462D4A614E635266556A586E3272357538782F413F4428472B4B6250655367566B5970337336763979244226452948404D635166546A576D5A7134743777217A25432A462D4A614E645267556B58703272357538782F413F4428472B4B625065',
        reCaptchaSiteKey: '6Lf9UZgqAAAAAFbFO2DNEP1eG19xHGOXFk6GEqoz',
        instrumentationKey: '870ee253-aefe-4d6d-8657-79e51b6fd549',
        testEmailIds: 'chris.tudor@hydratight.com',
        blobPublic: 'https://idmsstorageaccount.blob.core.windows.net/dev-public/',
    };
    private prodConfig = {
        clientId: '181f240e-80df-49d9-a2d8-5dbefd26e466',
        subValue: '4d8a8ce2d781457d813024ff74e740f3',

        azureEncKey:
            '2F423F4528482B4D6251655468566D597133743677397A24432646294A404E635266556A586E5A7234753778214125442A472D4B6150645367566B59703373357638792F423F4528482B4D6251655468576D5A7134743777397A24432646294A404E635266556A586E3272357538782F413F442A472D4B6150645367566B59703373367639792442264529482B4D6251655468576D5A7134743777217A25432A462D4A614E635266556A586E3272357538782F413F4428472B4B6250655367566B5970337336763979244226452948404D635166546A576D5A7134743777217A25432A462D4A614E645267556B58703272357538782F413F4428472B4B625065',
        reCaptchaSiteKey: '6LdSU5gqAAAAADRPxwzzXUwlGvudf5MPRbk_48vE',
        instrumentationKey: 'bcd97f2a-8015-486c-9404-004be9183340',
        testEmailIds: 'integrity.support@hydratight.com',
        blobPublic: 'https://idmsstorageaccount.blob.core.windows.net/dev-public/',
    };
    constructor() {}
    getConfig() {
        if (environment.environmentName == 'dev') {
            return this.devConfig;
        } else if (environment.environmentName == 'qa') {
            return this.qaConfig;
        } else if (environment.environmentName == 'uat') {
            return this.uatConfig;
        } else if (environment.environmentName == 'prod') {
            return this.prodConfig;
        }
    }
}
